import { css } from '@emotion/react'
import mediaQueries from '@/layout/media-queries'

export const SIZES = {
  ICON: {
    MOBILE: '42px',
    COMPACT: '74px',
    DEFAULT: '124px',
  },
}

const mediaQuery = () => mediaQueries.mediumScreen()

export const wrapperCss = (theme) => css`
  background-color: ${theme.colors.white};
  z-index: 1;

  ${mediaQueries.smallScreen()} {
    position: sticky;
    top: 106px;
    padding-top: 20px;
    padding-right: 25px;
    padding-left: 25px;
    margin-right: -25px;
    margin-left: -25px;
    z-index: 3;
  }
  ${mediaQueries.mediumScreen(100)} {
    top: ${theme.header.height};
    padding-top: 0px;
  }
`

export const headerCss = () => css`
  display: grid;
  grid-template-columns: min-content 1fr min-content;
  grid-template-rows: min-content 1fr;
  grid-template-areas:
    'icon name action'
    'description description description';
  margin-bottom: 26px;
  position: relative;
  z-index: 10;
  ${mediaQuery()} {
    grid-template-columns: min-content minmax(200px, auto) min-content;
    grid-template-rows: ${SIZES.ICON.MOBILE} 1fr;
    grid-template-areas:
      'icon name action'
      'icon description action';
  }
`

export const nameCss = () => css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  grid-area: name;
  font-size: 22px;
  font-weight: 700;
  line-height: 32px;
  padding: 8px, 0px, 8px, 0px;
  ${mediaQuery()} {
    transition: transform 0.2s ease-out;
    line-height: initial;
    font-size: 30px;
    padding: 0px 16px 0px 0px;
  }
`

export const descriptionWrapperCss = () => css`
  grid-area: description;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0;
  max-width: 100%;
  ${mediaQuery()} {
    transition: transform 0.2s ease-out;
    font-size: 16px;
    padding: 0;
  }
`

export const descriptionCss = (isCompact) => css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  overflow: hidden;
  max-width: inherit;
  transition: opacity 0.2s ease-out, max-height 0.2s ease-out;
  max-height: ${isCompact ? '0' : '80px'};
  opacity: ${isCompact ? `0` : `1`};
  ${mediaQuery()} {
    padding-right: 16px;
  }
`
